import React from 'react'
import { Icon } from '@conekta/frontino-ui/Icon'
import { TFunction } from 'i18next'
import './LifeTestAsideContent.scss'

export const LifeTestAsideContent = (t: TFunction): JSX.Element => {
  const tRoot = 'bluebook.aside.inProcessProofOfLife.advices'
  return (
    <ul className='life-test-aside-content'>
      <li className='life-test-aside-content-li'>
        <Icon className='icon'>check</Icon>
        <p>{t(`${tRoot}.checkYourFace`).toString()}</p>
      </li>
      <li className='life-test-aside-content-li'>
        <Icon className='icon'>check</Icon>
        <p>{t(`${tRoot}.DontUseCap`).toString()}</p>
      </li>
    </ul>
  )
}
